export default __webpack_public_path__ + "static/media/page2.050e8aa8.pdf";